<!-- Hidden inside the native app; dismissible on the web. -->
@if (!platform.isNativePlatform() && !dismissed()) {
  <aside class="app-banner">
    <img class="app-banner__icon" src="assets/icons/icon-192x192.png" alt="RealGuest CheckIn">
    <div class="app-banner__body">
      <div class="app-banner__text">
        <span class="app-banner__title">{{ 'home.banner.title' | translate }}</span>
        <span class="app-banner__subtitle">{{ 'home.banner.subtitle' | translate }}</span>
      </div>
      <div class="app-banner__actions">
        <a class="store-badge" [href]="appStoreUrl" target="_blank" rel="noopener">
          <img [src]="appStoreBadge" alt="Download on the App Store">
        </a>
        <a class="store-badge" [href]="playStoreUrl" target="_blank" rel="noopener">
          <img [src]="playStoreBadge" alt="Get it on Google Play">
        </a>
      </div>
    </div>
    <button mat-icon-button class="app-banner__dismiss" (click)="dismiss()"
            [attr.aria-label]="'common.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </aside>
}
